"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var angulartics2_1 = require("angulartics2");
var core_1 = require("@angular/core");
var core_2 = require("@ngx-translate/core");
var Observable_1 = require("rxjs/Observable");
var CalendarComponent = (function () {
    function CalendarComponent(cdRef, translate, angulartics2) {
        this.cdRef = cdRef;
        this.translate = translate;
        this.angulartics2 = angulartics2;
        this.weeks = [];
        this.days = [];
        this.dates = [0, 1, 2, 3, 4, 5, 6];
        this.disp = false;
        this.isPc = false;
        this.amount = "0";
        this.selectedDate = [];
        this.startYear = 1970;
        this.endYear = 2200;
        this.startMonth = 0;
        this.endMonth = 13;
        this.loading = true;
        this.deposit = false;
        this.eventLabel = "";
        this.clickDate = new core_1.EventEmitter();
        this.moveMonth = new core_1.EventEmitter();
        this.clickMask = new core_1.EventEmitter();
        this.hasNext = false;
    }
    CalendarComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.dayService) {
            return false;
        }
        var holidays = [];
        this.dayService.subscribe(function (dd) {
            console.log(dd);
            if (dd.loading) {
                _this.loading = dd.loading;
                return;
            }
            var month = _this.month;
            dd.forEach(function (data) {
                if (month === 13) {
                    month = 1;
                }
                _this.selectedDate[month] = [];
                data.days.forEach(function (date, i) {
                    _this.selectedDate[month][i + 1] = {
                        active: date !== null && date.length > 0,
                        deposit_accepted: false
                    };
                    if (date && date.length > 0) {
                        if (date[0].deposit_accepted) {
                            _this.selectedDate[month][i + 1].deposit_accepted = true;
                        }
                    }
                });
                data.holidays.forEach(function (holiday) {
                    holidays.push(holiday.date);
                });
                month++;
            });
            _this.hasNext = dd[0].has_next_month;
            var d = new Date(_this.year, _this.month - 1, 1);
            var ld = new Date(_this.year, _this.month, 0);
            var lastMonth = new Date(_this.year, _this.month - 1, 0);
            var now = new Date();
            now.setHours(0);
            now.setMinutes(0);
            now.setSeconds(0);
            now.setMilliseconds(0);
            var week = 0;
            var lastDate = ld.getDate();
            var day = d.getDay();
            _this.weeks = [];
            _this.weeks.push([]);
            var lastMD = lastMonth.getDate();
            var lastY = lastMonth.getFullYear();
            var lastM = lastMonth.getMonth() + 1;
            for (var _d = 0; _d < day; _d++) {
                var date = lastMD - day + _d + 1;
                _this.weeks[0][_d] = {};
                _this.weeks[0][_d].year = lastY;
                _this.weeks[0][_d].month = lastM;
                _this.weeks[0][_d].date = date;
                _this.weeks[0][_d].holiday =
                    holidays.indexOf(lastY + "-" + ("0" + lastM).slice(-2) + "-" + ("0" + date).slice(-2)) > -1;
                _this.weeks[0][_d].prev =
                    new Date(_this.year, _this.month - 1, date) < now;
                _this.weeks[0][_d].now =
                    new Date(lastY, lastM - 1, date).getTime() == now.getTime();
            }
            for (var date = 1; date <= lastDate; date++) {
                _this.weeks[week][day] = {};
                _this.weeks[week][day].year = _this.year;
                _this.weeks[week][day].month = _this.month;
                _this.weeks[week][day].date = date;
                _this.weeks[week][day].holiday =
                    holidays.indexOf(_this.year + "-" + ("0" + _this.month).slice(-2) + "-" + ("0" + date).slice(-2)) > -1;
                _this.weeks[week][day].prev =
                    new Date(_this.year, _this.month - 1, date) < now;
                _this.weeks[week][day].now =
                    new Date(_this.year, _this.month - 1, date).getTime() == now.getTime();
                day++;
                if (date < lastDate && day === 7) {
                    day = 0;
                    week++;
                    _this.weeks.push([]);
                }
                if (date === lastDate) {
                    var nd = 1;
                    var month_1 = _this.month + 1;
                    var year = _this.year;
                    if (month_1 === 13) {
                        month_1 = 1;
                        year++;
                    }
                    for (var _d = day; _d < 7; _d++) {
                        _this.weeks[week][_d] = {};
                        _this.weeks[week][_d].year = year;
                        _this.weeks[week][_d].month = month_1;
                        _this.weeks[week][_d].date = nd++;
                        _this.weeks[week][_d].holiday =
                            holidays.indexOf(year + "-" + ("0" + month_1).slice(-2) + "-" + ("0" + (nd - 1)).slice(-2)) > -1;
                        _this.weeks[week][_d].prev = new Date(year, month_1 - 1, nd) < now;
                        _this.weeks[week][_d].now =
                            new Date(year, month_1 - 1, nd).getTime() == now.getTime();
                    }
                    if (week < 5) {
                        for (var wlen = week; wlen < 5; wlen++) {
                            _this.weeks.push([]);
                            var wlen_1 = _this.weeks.length - 1;
                            for (var _d = 0; _d < 7; _d++) {
                                _this.weeks[wlen_1][_d] = {};
                                _this.weeks[wlen_1][_d].year = year;
                                _this.weeks[wlen_1][_d].month = month_1;
                                _this.weeks[wlen_1][_d].date = nd++;
                                _this.weeks[wlen_1][_d].holiday =
                                    holidays.indexOf(year + "-" + ("0" + month_1).slice(-2) + "-" + ("0" +
                                        (nd - 1)).slice(-2)) > -1;
                                _this.weeks[wlen_1][_d].prev = new Date(year, month_1 - 1, nd) < now;
                                _this.weeks[wlen_1][_d].now =
                                    new Date(year, month_1 - 1, nd).getTime() == now.getTime();
                            }
                        }
                    }
                }
            }
            _this.selectedDate = _this.selectedDate || [];
            _this.prevMonth = _this.month - 1 === 0 ? 12 : _this.month - 1;
            _this.nextMonth = _this.month + 1 === 13 ? 1 : _this.month + 1;
            console.log(_this.disp);
            console.log(_this.month);
            if (_this.disp) {
            }
            _this.loading = false;
        });
    };
    CalendarComponent.prototype.ngOnChanges = function (changes) {
        if (this.amount) {
            this.amount = this.amount.toString().replace(/(\d)(?=(\d{3})+$)/g, "$1,");
        }
    };
    CalendarComponent.prototype.onClick = function ($event, d) {
        $event.preventDefault();
        if (/[0-9]+/.test(d.date) && this.selectedDate[d.month][d.date].active) {
            if (this.eventLabel) {
                this.angulartics2.eventTrack.next({
                    action: "click",
                    properties: { category: "search", label: this.eventLabel }
                });
            }
            d.deposit_accepted = this.selectedDate[d.month][d.date].deposit_accepted;
            this.clickDate.next(d);
            this.loading = true;
        }
    };
    CalendarComponent.prototype.onClose = function ($event) {
        this.clickMask.next($event);
    };
    CalendarComponent.prototype.onPrevMonth = function (month) {
        var year = month === 12 ? this.year - 1 : this.year;
        if ((year > this.startYear ||
            (year === this.startYear && month >= this.startMonth)) &&
            !this.loading) {
            this.loading = true;
            this.month = month;
            this.year = year;
            this.prevMonth = month === 1 ? 12 : month - 1;
            this.nextMonth = month === 12 ? 1 : month + 1;
            this.moveMonth.next({
                year: year,
                month: month,
                prev: true
            });
        }
    };
    CalendarComponent.prototype.onNextMonth = function (month) {
        var year = month === 1 ? this.year + 1 : this.year;
        if (this.hasNext && !this.loading) {
            this.loading = true;
            this.month = month;
            this.year = year;
            this.nextMonth = month === 12 ? 1 : month + 1;
            this.prevMonth = month === 1 ? 12 : month - 1;
            this.moveMonth.next({
                year: year,
                month: month,
                prev: false
            });
        }
    };
    return CalendarComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], CalendarComponent.prototype, "isPc", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], CalendarComponent.prototype, "amount", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], CalendarComponent.prototype, "year", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], CalendarComponent.prototype, "month", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], CalendarComponent.prototype, "selectedDate", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], CalendarComponent.prototype, "startYear", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], CalendarComponent.prototype, "endYear", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], CalendarComponent.prototype, "startMonth", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], CalendarComponent.prototype, "endMonth", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Observable_1.Observable)
], CalendarComponent.prototype, "dayService", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], CalendarComponent.prototype, "loading", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], CalendarComponent.prototype, "deposit", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], CalendarComponent.prototype, "eventLabel", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], CalendarComponent.prototype, "clickDate", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], CalendarComponent.prototype, "moveMonth", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], CalendarComponent.prototype, "clickMask", void 0);
CalendarComponent = __decorate([
    core_1.Component({
        selector: "trt-calendar",
        template: "\n    <div id=\"trt-calendar\" [ngClass]=\"{ pc: isPc, deposit: deposit }\">\n      <div class=\"head\">\n        <span class=\"moveMonth\" (click)=\"onPrevMonth(prevMonth)\"\n          >&lt; {{ prevMonth }}{{ \"MONTH\" | translate }}</span\n        >\n        <span class=\"currentMonth\">{{\n          \"YEAR_MONTH\" | translate: { year: year, month: month }\n        }}</span>\n        <span class=\"moveMonth\" (click)=\"onNextMonth(nextMonth)\"\n          >{{ nextMonth }}{{ \"MONTH\" | translate }} &gt;</span\n        >\n      </div>\n      <div class=\"body\">\n        <div class=\"week-day\">\n          <span class=\"sunday\">{{ \"SUN\" | translate }}</span\n          ><span class=\"monday\">{{ \"MON\" | translate }}</span\n          ><span class=\"tuesday\">{{ \"TUE\" | translate }}</span\n          ><span class=\"wednesday\">{{ \"WED\" | translate }}</span\n          ><span class=\"thursday\">{{ \"THU\" | translate }}</span\n          ><span class=\"friday\">{{ \"FRI\" | translate }}</span\n          ><span class=\"saturday\">{{ \"SAT\" | translate }}</span>\n        </div>\n        <div class=\"cal\" *ngIf=\"loading\">\n          <span class=\"blink\"><i class=\"icon icon_calendar\"></i></span>\n        </div>\n        <div\n          *ngFor=\"let week of weeks\"\n          [ngStyle]=\"{ opacity: loading ? 0 : 1 }\"\n        >\n          <a\n            *ngFor=\"let date of dates\"\n            (click)=\"\n              onClick($event, {\n                year: week[date].year,\n                month: week[date].month,\n                date: week[date].date\n              })\n            \"\n            [ngClass]=\"{ holiday: week[date].holiday }\"\n            ><span\n              *ngIf=\"\n                week[date].date == 1 &&\n                week[date].month != month &&\n                !week[date].prev\n              \"\n              class=\"month\"\n              >{{ week[date].month }}{{ \"MONTH\" | translate }}</span\n            ><span\n              [ngClass]=\"{\n                active:\n                  selectedDate[week[date].month] &&\n                  selectedDate[week[date].month][week[date].date].active,\n                disabled:\n                  !!!selectedDate[week[date].month] ||\n                  !!!selectedDate[week[date].month][week[date].date].active,\n                sunday: date == 0,\n                monday: date == 1,\n                tuesday: date == 2,\n                wednesday: date == 3,\n                thursday: date == 4,\n                friday: date == 5,\n                saturday: date == 6,\n                selected:\n                  selectedDate[week[date].month] &&\n                  selectedDate[week[date].month][week[date].date]\n                    .deposit_accepted\n              }\"\n              >{{ week[date].date }}</span\n            ></a\n          >\n        </div>\n      </div>\n      <div class=\"foot\" *ngIf=\"deposit\">\n        <p>{{ \"CALENDAR_DEPOSIT\" | translate }}</p>\n        <p>{{ \"DEPOSIT_AMOUNT\" | translate: { amount: amount } }}</p>\n        <p class=\"cancel\">{{ \"DEPOSIT_CANCEL\" | translate }}</p>\n      </div>\n    </div>\n    <trt-mask *ngIf=\"isPc\" (clickEvent)=\"onClose()\"></trt-mask>\n  ",
        styles: [require('./calendar.component.css')]
    }),
    __metadata("design:paramtypes", [core_1.ChangeDetectorRef,
        core_2.TranslateService,
        angulartics2_1.Angulartics2])
], CalendarComponent);
exports.CalendarComponent = CalendarComponent;
